<main>
  <div class="contenedor relative">
     
    <div class="btn-cerrar absolute top-2 right-2 cursor-pointer" (click)="dialogRef.close()">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500 hover:text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </div>
 
    <div class="cont-sup text-xs flex items-center gap-5 mt-6 mb-4 px-2">
      <div class="cont-filtro flex-1">
        <div class="relative">
          <input
            type="text"
            class="w-full border border-gray-300 rounded px-3 py-2 pr-8 text-sm focus:outline-none focus:ring focus:border-blue-500"
            placeholder="Ingrese descripción"
            [(ngModel)]="searchTerm"
            (ngModelChange)="filtrar()"
            (keydown.enter)="onSearch()"
            maxlength="50"
          />
          <button
            *ngIf="searchTerm"
            class="absolute right-2 top-2 text-gray-400 hover:text-gray-700"
            (click)="searchTerm=''; onSearch()"
          >
            ✕
          </button>
        </div>
      </div>

      <button
        class="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded hover:bg-blue-700 h-[40px]"
        (click)="onSearch()"
      >
        Buscar
      </button>
    </div>
 
    <div class="cont-result">
      <div class="img-nf text-center text-sm text-gray-500 py-4" *ngIf="centrosCosto.length === 0">
        <h5>Sin Centro de Costos</h5>
      </div>
 
      <div
        class="lista max-h-[45vh] overflow-y-auto border rounded"
        *ngIf="centrosCosto.length > 0"
      > 
        <div class="grid grid-cols-2 bg-gray-200 font-medium text-gray-700 text-xs border-b border-gray-400 sticky top-0 z-10">
          <div class="px-2 py-2">Código</div>
          <div class="px-2 py-2">Descripción</div>
        </div>
 
        <div
          class="grid grid-cols-2 hover:bg-blue-50 cursor-pointer border-b border-gray-200 text-sm"
          *ngFor="let cenco of centrosCostoFiltrados"
          (click)="seleccionar(cenco)"
        >
          <div class="px-2 py-2">{{ cenco.codi_cenco }}</div>
          <div class="px-2 py-2">{{ cenco.descrip_cenco }}</div>
        </div>
                <div
          class="grid grid-cols-2 hover:bg-blue-50 cursor-pointer border-b border-gray-200 text-sm"
          *ngFor="let cenco of centrosCostoFiltrados"
          (click)="seleccionar(cenco)"
        >
          <div class="px-2 py-2">{{ cenco.codi_cenco }}</div>
          <div class="px-2 py-2">{{ cenco.descrip_cenco }}</div>
        </div>

                <div
          class="grid grid-cols-2 hover:bg-blue-50 cursor-pointer border-b border-gray-200 text-sm"
          *ngFor="let cenco of centrosCostoFiltrados"
          (click)="seleccionar(cenco)"
        >
          <div class="px-2 py-2">{{ cenco.codi_cenco }}</div>
          <div class="px-2 py-2">{{ cenco.descrip_cenco }}</div>
        </div>

                <div
          class="grid grid-cols-2 hover:bg-blue-50 cursor-pointer border-b border-gray-200 text-sm"
          *ngFor="let cenco of centrosCostoFiltrados"
          (click)="seleccionar(cenco)"
        >
          <div class="px-2 py-2">{{ cenco.codi_cenco }}</div>
          <div class="px-2 py-2">{{ cenco.descrip_cenco }}</div>
        </div>
      </div>
    </div>
  </div>
</main>
